import React from "react";
import { Link, Outlet, useLocation } from "react-router-dom";

export default function CSP(props) {
  const location = useLocation();
  const currentPath = location.pathname;

  const CSPPolicies = [
    {
      path: "/csppolicy/",
      name: "Policy statement, Aims, Objectives and Commitment",
    },
    {
      path: "/csppolicy/scope",
      name: "Definitions & Scope of the Policy ",
    },
    {
      path: "/csppolicy/risk-mitigation",
      name: "Risk Mitigation",
    },
    {
      path: "/csppolicy/goodpractices",
      name: "Promoting Good Practices",
    },
    {
      path: "/csppolicy/recruitment-and-training",
      name: "Recruitment and training of SS/KVS staff ",
    },
    {
      path: "/csppolicy/reporting-concerns",
      name: "Reporting & Recording of concerns about suspected poor practices and/ or abuse ",
    },
    {
      path: "/csppolicy/allegations",
      name: "Responding to allegations or suspicions about suspected poor practice and/or child abuse",
    },
    { path: "/csppolicy/bullying", name: "Bullying" },
    {
      path: "/csppolicy/itsm",
      name: "Use of Information Technology and Social Media",
    },
    {
      path: "/csppolicy/confidentiality",
      name: "Confidentiality",
    },
    {
      path: "/csppolicy/safeguarding-group",
      name: "Child Safeguarding & Protection Group at Slum Soccer",
    },
    {
      path: "/csppolicy/review-and-approval",
      name: "Oversight, Amendments, Review & Approval",
    },
    {
      path: "/csppolicy/annexure1",
      name: "Annexure 1",
    },
    {
      path: "/csppolicy/annexure2",
      name: "Annexure 2",
    },
    {
      path: "/csppolicy/annexure3",
      name: "Annexure 3",
    },
    {
      path: "/csppolicy/annexure4",
      name: "Annexure 4",
    },
    {
      path: "/csppolicy/annexure5",
      name: "Annexure 5",
    },
    {
      path: "/csppolicy/annexure6",
      name: "Annexure 6",
    },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-gray-50">
      <div className="bg-gradient-to-r from-[#efc94c] to-[#f0ce5d] py-16 pt-32">
        <div className="container mx-auto px-6">
          <h1 className="text-4xl font-bold text-white mb-4 text-center">
            Child Safeguarding & Protection Policy (Version 5)
          </h1>
          <p className="text-sm text-white text-center italic">
            This Version 5 of the Policy has been approved by Dr. Abhijeet
            Barse, CEO Slum Soccer and is effective from March 1, 2025.
          </p>
        </div>
      </div>

      {/* Main Content area */}
      <div className="container mx-auto px-6 py-8">
        <div className="flex flex-col md:flex-row gap-8">
          {/* Sidebar navigation */}
          <div className="md:w-1/4">
            <div className="bg-white rounded-xl shadow-sm p-6">
              <h3 className="text-lg font-semibold text-gray-800 mb-4">
                Child Safeguarding & Protection Policy
              </h3>
              <ul className="space-y-2">
                {CSPPolicies.map((policy, index) => (
                  <li key={index}>
                    <Link
                      to={policy.path}
                      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                      className={`block p-2 rounded-lg transition-colors ${
                        currentPath === policy.path
                          ? "bg-yellow-50 text-yellow-500 font-medium"
                          : "text-gray-600 hover:bg-gray-50"
                      }`}
                    >
                      {policy.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Main content area */}
          <div className="md:w-3/4">
            <div className="bg-white rounded-xl shadow-sm p-8">
              <Outlet />
            </div>
          </div>
        </div>

        {/* Added notification box at the bottom */}
        <div className="mt-8">
          <div className="rounded-xl p-6 bg-[#efc94c] text-white font-bold">
            <p>
              Please email or report any incident related to Child Safeguarding
              & Protection Policy to Slum Soccer Child Protection Officer Mr.
              Pankaj Mahajan at{" "}
              <a
                href="mailto:pankaj.mahajan@slumsoccer.org"
                className="hover:underline"
              >
                pankaj.mahajan@slumsoccer.org
              </a>{" "}
              Mob.{" "}
              <a href="tel:+919860556506" className="hover:underline">
                +91 9860556506.
              </a>{" "}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
